import { FunctionComponent } from 'react';
import { EnvService } from '@hub/services/core/env-service';
import { getTradingPlatform } from '@monorepo/client-common';
import { Flex, TradingSystemBtn } from '@monorepo/react-components';
import { TradingSystem } from '@monorepo/types';

const isProduction = EnvService.isProduction;

interface TradingPlatformsProps {
  tradingSystem: TradingSystem;
}

export const TradingPlatforms: FunctionComponent<TradingPlatformsProps> = ({
  tradingSystem,
}) => {
  const platformData = getTradingPlatform(tradingSystem, isProduction);

  return (
    <Flex gap={4} wrap={'wrap'}>
      {platformData.map((platformItem) => (
        <TradingSystemBtn
          platformData={platformItem}
          key={platformItem.platform}
        />
      ))}
    </Flex>
  );
};
